module.exports = __webpack_public_path__ + "img/6-Bonne-réponse.8cd05ff4.png";